import { render, staticRenderFns } from "./BotaoPrimario.vue?vue&type=template&id=64b38a60"
import script from "./BotaoPrimario.vue?vue&type=script&lang=js"
export * from "./BotaoPrimario.vue?vue&type=script&lang=js"
import style0 from "./BotaoPrimario.vue?vue&type=style&index=0&id=64b38a60&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports